module.exports = __webpack_public_path__ + "files/SPIADI2022 - Rapport RÉA explAUR.fe7b64e063abc643d80124df90cc4def.pdf";